import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/report-basic-salary-histories',
    name: 'report-basic-salary-history',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-basic-salary-history/index.vue')
  }
]
